// This file dynamically exports only the theme needed based on environment variables
// and gets optimized at build time through tree-shaking

import { ThemeOptions } from '@mui/material/styles'
import cleartripTheme from './cleartrip'
import flyinTheme from './flyin'

// For build-time optimization, we use conditional exports
// The unused theme will be tree-shaken away during the build process
const VARIANT = process.env.NEXT_PUBLIC_VARIANT || 'FLYIN'

let selectedTheme: ThemeOptions

if (VARIANT === 'CLEARTRIP') {
    selectedTheme = cleartripTheme
} else if (VARIANT === 'FLYIN') {
    selectedTheme = flyinTheme
} else {
    // Default fallback
    selectedTheme = flyinTheme
}

// Additional theme-specific customizations based on common animation keyframes
const themeWithAnimations: ThemeOptions = {
    ...selectedTheme,
    components: {
        ...selectedTheme.components,
        MuiCssBaseline: {
            styleOverrides: {
                '@keyframes ping': {
                    '75%, 100%': {
                        transform: 'scale(2)',
                        opacity: 0
                    }
                }
            }
        }
    }
}

export default themeWithAnimations
